var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Printer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 12V22C30 22.2652 29.8946 22.5196 29.7071 22.7071C29.5196 22.8946 29.2652 23 29 23H25V27C25 27.2652 24.8946 27.5196 24.7071 27.7071C24.5196 27.8946 24.2652 28 24 28H8C7.73478 28 7.48043 27.8946 7.29289 27.7071C7.10536 27.5196 7 27.2652 7 27V23H3C2.73478 23 2.48043 22.8946 2.29289 22.7071C2.10536 22.5196 2 22.2652 2 22V12C2 10.3463 3.42 9 5.16625 9H7V5C7 4.73478 7.10536 4.48043 7.29289 4.29289C7.48043 4.10536 7.73478 4 8 4H24C24.2652 4 24.5196 4.10536 24.7071 4.29289C24.8946 4.48043 25 4.73478 25 5V9H26.8337C28.58 9 30 10.3463 30 12ZM9 9H23V6H9V9ZM23 20H9V26H23V20ZM25 14.5C25 14.2033 24.912 13.9133 24.7472 13.6666C24.5824 13.42 24.3481 13.2277 24.074 13.1142C23.7999 13.0006 23.4983 12.9709 23.2074 13.0288C22.9164 13.0867 22.6491 13.2296 22.4393 13.4393C22.2296 13.6491 22.0867 13.9164 22.0288 14.2074C21.9709 14.4983 22.0007 14.7999 22.1142 15.074C22.2277 15.3481 22.42 15.5824 22.6666 15.7472C22.9133 15.912 23.2033 16 23.5 16C23.8978 16 24.2794 15.842 24.5607 15.5607C24.842 15.2794 25 14.8978 25 14.5Z",
    fill: "#F99C5F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterB);
export default __webpack_public_path__ + "static/media/PrinterB.ee57424bbd864c536948bcc8d8132f03.svg";
export { ForwardRef as ReactComponent };